import { NavTab } from '../../../../types/graphql'

import { RegionLocaleTab } from './RegionLocaleTab'

export function useRegionLocaleTab(): NavTab {
  const localeTab: NavTab = {
    __typename: 'NavTab',
    ariaLabel: 'Region and Locale',
    href: null,
    id: 'regionlocale',
    render: () => <RegionLocaleTab />,
    sections: [
      {
        __typename: 'NavRegionLocaleSection',
        id: 'locale',
      },
    ],
    text: '',
    textColor: null,
    wrapperElement: 'button',
    alternateModelVariant: null,
  }

  return localeTab
}
